import { graphql } from '@/generated/gql';

export const INTAKE_QUOTE_QUERY = graphql(/* GraphQL */ `
  query IntakeQuote($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id
        status
        request {
          commodityGroupId
        }
        quote {
          id
          currency
          quoteReference
          lineItems {
            id
            title
            description
            quantity
            pricePerUnit
            unitId
            position
            sequence
            earlyDeliveryAt
            lateDeliveryAt
            commodityGroupId
          }
        }
      }
    }
  }
`);
